export default "__VITE_ASSET__COA5tnpb__"